// extracted by mini-css-extract-plugin
module.exports = {"container":"Indicator_container_2MeYx"};